module.exports = __webpack_public_path__ + "static/media/routerizador.0005769b.png";